module.exports = __webpack_public_path__ + "5d77a34f113a0626d6517dc18d743b68.jpg";